import isEqual from 'lodash/isEqual';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StateCompare = [any, any];

export function useIsChanged(...args: StateCompare[]): boolean {
  return args.some(
    ([source, state]) =>
      typeof source !== typeof state || !isEqual(source, state),
  );
}
